import { bodyTypesData, fuelTypesData, transmissionTypeData } from "@cinch-nx/data-search";
export const hydrate = (data, type)=>data.map(({ label , value  })=>({
            label: `${label} cars`,
            value,
            searchValue: label.toLowerCase(),
            type
        }));
const LocalSearchData = [
    ...hydrate(fuelTypesData, "fuelType"),
    ...hydrate(bodyTypesData, "bodyType"),
    ...hydrate(transmissionTypeData, "gearbox")
];
export default LocalSearchData;
